import { List } from "../../DiscoveryEngine.TS/Utils/List";
import { ObjSerUtils } from "../../DiscoveryEngine.TS/Serialization/ObjSerUtils";
import { ViewerDeviceGroupTreeNodeDto } from "./ViewerDeviceGroupTreeNodeDto";
import { Owner } from "./Owner";

export class ViewerDeviceGroupContainerDto extends ViewerDeviceGroupTreeNodeDto {

	public ContainerGuids: List<string>;
	public GroupGuids: List<string>;

	constructor(userGuid?: string, scopeGuid?: string, owner?: Owner,
				image?: string, name?: string, tagGuid?: string) {
		super(userGuid, scopeGuid, owner, image, name, tagGuid);

		this.ContainerGuids = new List<string>();
		this.GroupGuids = new List<string>();
	}

	public get HasContainers(): boolean {
		return (this.ContainerGuids && this.ContainerGuids.Count > 0);
	}

	public get HasGroups(): boolean {
		return (this.GroupGuids && this.GroupGuids.Count > 0);
	}

	public Write(obj: any, context: any): void {
		obj.viewer_device_group_container = {};
		obj = obj.viewer_device_group_container;

		super.Write(obj, context);

		if (this.HasContainers) {
			obj.container_guids = [];
			ObjSerUtils.WriteStringValueCollection(obj.container_guids, this.ContainerGuids, context);
		}

		if (this.HasGroups) {
			obj.group_guids = [];
			ObjSerUtils.WriteStringValueCollection(obj.group_guids, this.GroupGuids, context);
		}
	}

	public Read(obj: any, context: any): void {
		if (!obj.viewer_device_group_container)
			throw new Error();
		obj = obj.viewer_device_group_container;

		super.Read(obj, context);

		if (obj.container_guids !== undefined) {
			ObjSerUtils.ReadStringValueCollection(obj.container_guids, this.ContainerGuids, context);
		}

		if (obj.group_guids !== undefined) {
			ObjSerUtils.ReadStringValueCollection(obj.group_guids, this.GroupGuids, context);
		}
	}

}
